import React from 'react'
import App from './app'
import Login from './components/login'
import ForgotPassword from './components/forgotPassword'
import VerifyCode from './components/verifyCode'
import ResetPassword from './components/resetPassword'
import {connect} from 'react-redux'
import {withRouter, Route} from 'react-router-dom'
import testToken from './actions/token'
import MessageBox from './components/messageBox'
import CustomModal from './components/utilities/modals/CustomModal'

const Root = ({auth, dispatch}) => {

    /**
     * @TODO Discover the purpose of this function
     * @question1 Why is this function here?
     * @question2 What does it do for the whole application operation?
     */
        if(auth.access_token){
            dispatch(testToken(
                'providers',
                auth.access_token
            ))
        }
    /** ==================================================== */

    return (
        <div id="main-web-app-view">
            {
                auth.authenticated ? 
                <App /> : 
                <div>
                    <Route path="/" component={Login} />
                    <Route path="/forgot-password" component={ForgotPassword} />
                    <Route path="/verify-code" component={VerifyCode} />
                    <Route path="/update-password" component={ResetPassword} />
                </div>
            }
            {
                <MessageBox />
            }
            {
                <CustomModal/>
            }
        </div>
    )
}

function mapStateToProps(state){
    return {
        auth: state.auth
    }
}

export default withRouter(connect(mapStateToProps)(Root))


// WEBPACK FOOTER //
// ./src/root.js